export default __webpack_public_path__ + "assets/beaker-component.5b7ece09.svg";